export const formatToCurrency = (value: number) => {
	return (value / 100).toLocaleString("de-DE", {
		style: "currency",
		currency: "EUR",
		minimumFractionDigits: 0,
	});
};
